$(function(){
    $('.MojeEucHeroBannerCarousel').owlCarousel({
        loop: true,
        nav: true,
        items: 1,
        navText: [
            '<div class="shadow bg-white rounded-circle overflow-hidden p-3"><svg class="icon-chevron-left-large text-primary"><use xlink:href="#icon-chevron-left"></use></svg></div>',
            '<div class="shadow bg-white rounded-circle overflow-hidden p-3"><svg class="icon-chevron-right-large text-primary"><use xlink:href="#icon-chevron-right"></use></svg></div>'
        ],
        navContainerClass: 'owl-nav container d-none d-lg-flex',
        dots: false,
        margin: 15,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: true
    });
});